export default __webpack_public_path__ + "static/media/Kannada_education_m.a2b83363.wav";